var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.globalLoading)?_c('v-progress-circular',{attrs:{"size":20,"indeterminate":"","color":"primary"}}):_c('div',[(_vm.shouldAdminDashboardShow())?_c('AdminDashboard'):(_vm.shouldRacerDashboardShow())?_c('RacerDashboard'):(_vm.shouldDistrictManagerDashboard())?_c('DistrictManagerDashboard'):_c('SalespersonDashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }